// Computed data for charts
export const getLeadsByClient = (clients) => {
    return clients.map((agent) => ({
      name: agent.client_name,
      leads: agent.total_leads,
    }));
  };
  
  export const getLeadsByProperty = (properties) => {
    return properties.map((property) => ({
      name: property.property_name,
      leads: property.total_leads,
    }));
  };
  
  export const getLeadScoreDistribution = (score_distribution) => {
    const dist =
      score_distribution && !Array.isArray(score_distribution)
        ? score_distribution
        : {};

    return [
      { name: "Cold", value: Number(dist.cold) || 0, fill: "#9ca3af" },
      { name: "Warm", value: Number(dist.warm) || 0, fill: "#65a30d" },
      { name: "Hot", value: Number(dist.hot) || 0, fill: "#16a34a" },
    ];
  };
  

export const getWeeklyLeadsTrend = (weekly) => {
    return weekly.map((week) => ({
      name: week.label,
      leads: week.count,
    }));
  };
export const getMonthlyLeadsTrend = (monthly) => {
    return monthly.map((month) => ({
      name: month.label,
      leads: month.count,
    }));
  };
export const getDailyLeadsTrend = (daily) => {
    return daily.map((day) => ({
      name: day.label,
      leads: day.count,
    }));
  };